import styled, { keyframes } from 'styled-components';
import { MdSync } from 'react-icons/md';

export { Paragraph } from '../../../styles';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const SpinningIcon = styled(MdSync)`
  animation: ${rotate} 1.6s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
